export default __webpack_public_path__ + "static/media/no_polls_icon.47eae4a1.svg";